export interface AgentChoiceOption {
  key: string;
  label: string;
}

/** Choice widgets produce a user reply; they never execute a navigation action. */
export function parseChoice(
  raw: unknown,
): { id: string; options: AgentChoiceOption[] } | undefined {
  try {
    const value = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (
      !value ||
      (value.version !== 1 && value.version !== undefined) ||
      !Array.isArray(value.widgets) ||
      value.widgets.length !== 1
    )
      return;
    const widget = value.widgets[0];
    if (widget?.type !== 'choice' || !Array.isArray(widget.options)) return;
    const options: AgentChoiceOption[] = [];
    for (const option of widget.options) {
      if (
        typeof option?.key !== 'string' ||
        !option.key.trim() ||
        typeof option.label !== 'string' ||
        !option.label.trim()
      )
        return;
      const key = option.key.trim();
      if (options.some((item) => item.key === key)) return;
      options.push({ key, label: option.label.trim() });
    }
    if (options.length < 2) return;
    return { id: typeof widget.id === 'string' ? widget.id : 'w1', options };
  } catch {
    return;
  }
}

export function formatChoiceReply(option: AgentChoiceOption): string {
  // Keep the fixed reply protocol aligned with the agent operations client.
  return `确认选项：${option.key} · ${option.label}`;
}
